import React, {useEffect, useMemo, useReducer, useState} from "react";
import ReactTable from "../../components/ReactTableWrapper";
import SweetAlert from "../../components/SweetAlertWrapper";

import connection from "../../connection";
import general from "../../general";
import withStyles from "@material-ui/core/styles/withStyles";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import SnackbarContent from "components/Snackbar/SnackbarContent.jsx";
import CardBody from "../../components/Card/CardBody";

import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Add from "@material-ui/icons/Add";

import cursosStyle from "assets/jss/material-dashboard-pro-react/views/cursosStyle";
import UserSearch from "../../components/UserSearch";
import {faEye, faEyeSlash, faSearchPlus, faTrashAlt} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import StateCircle from "../../components/StateCircle";
import useDebounce from "../../functions/useDebounce";

const Cursos = (props) => {
  const [modal, setModal] = useState(null);
  const {classes} = props;

  const CardDisponiveis = useMemo(() => {
    let C = () => {
      if (!general.userHasType("formando") && !general.userHasType("dirigente")) return null;

      const [state, setState] = useReducer(
        (state, newState) => ({...state, ...newState}),
        {
          filter: "",
          mostrar_outras_regioes: false,
          data: {cursos: []},
          page: 0,
          pageSize: 10
        });
      const debouncedFilter = useDebounce(state.filter, 500);

      const reloadCursos = () => {
        connection.get("curso/listagem", {
          disponiveis_apenas: true,
          regiao: state.mostrar_outras_regioes ? null : window.App.state.user.regiao,
          filtro: state.filter,
          numero_resultados: state.pageSize,
          pagina: state.page
        }).then((data) => {
          let cursos = data.cursos;
          cursos.forEach((curso) => {
            curso.modelo = curso.modelo && curso.modelo.designacao;
            curso.percurso = curso.percurso && curso.percurso.designacao;
            curso.actions = (<React.Fragment>
              <Button
                justIcon
                round
                simple
                onClick={() => {
                  window.App.hist.push("/curso/" + curso.id);
                }}
                style={{margin: 0}}
                color="info"
                className="edit"
              >
                <FontAwesomeIcon icon={faSearchPlus}/>
              </Button>
            </React.Fragment>);
          });
          setState({data: {cursos, paginacao: data.paginacao}})
        });
      }

      useEffect(() => {
        reloadCursos();
      }, [state.mostrar_outras_regioes, state.page, debouncedFilter])

      return <Card>
        <CardHeader color="primary">
          <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
            <h4 style={{flex: 1}}>Cursos disponíveis para inscrição{state.mostrar_outras_regioes ? "" : " da Região"}</h4>
            <CustomInput
              id="tableSearch"
              formControlProps={{
                className: classes.searchInput
              }}
              inputProps={{
                type: "text",
                name: "tableSearch",
                placeholder: "Pesquisar",
                onChange: (e) => {
                  setState({filter: e.target.value, page: 0});
                }
              }}
            />
          </div>
        </CardHeader>
        <ReactTable
          placeholder={general.userHasPermission("curso.criar") ? "Ainda não existe nenhum curso, clique em 'Novo Curso' para começar" : "Não existem cursos para apresentar"}
          data={state.data?.cursos}
          minRows={1}
          columns={[
            {
              Header: "Código",
              accessor: "descricao",
              Cell: (row) => {
                return <React.Fragment><StateCircle state={row.original['estado']}/>{row.original['descricao']}</React.Fragment>
              },
              width: 200
            },
            {
              Header: "Tipo",
              accessor: "tipo_curso",
              Cell: (row) => row.original.tipo_curso + (row.original.tags ? ' (' + row.original.tags + ')' : ''),
              width: 200
            },
            {
              Header: "Modalidade",
              accessor: "modalidade",
              Cell: (row) => row.original.modalidade + (row.original.tags ? ' (' + row.original.tags + ')' : '')
            },
            {
              Header: "Local",
              accessor: "regiao",
              width: 250,
              Cell: (row) => row.original.nucleo ? row.original.nucleo + ' / ' + row.original.regiao : row.original.regiao
            },
            {
              Header: "Diretor",
              accessor: "diretor",
              width: 150,
              Cell: general.Renderers.userRenderer
            },
            {
              Header: "",
              accessor: "actions",
              maxWidth: 105,
              sortable: false,
              filterable: false
            }
          ]}
          defaultPageSize={state.pageSize}
          showPaginationBottom={true}
          className="-striped -highlight"
          pages={state.data?.paginacao?.paginas}
          manual
          sortable={false}
          onFetchData={(state, instance) => {
            setState({page: state.page, pageSize: state.pageSize});
          }}
        />
        <CardBody style={{textAlign: "right"}}>
          <Button
            className={classes.addStuffButton + " " + classes.button + " " + classes.primary}
            onClick={() => setState({mostrar_outras_regioes: !state.mostrar_outras_regioes})}
            color="success">
            <FontAwesomeIcon icon={state.mostrar_outras_regioes ? faEyeSlash : faEye}/> {state.mostrar_outras_regioes ? "Ocultar" : "Mostrar"} Outras Regiões
          </Button>
        </CardBody>
      </Card>;
    };
    return <C/>
  }, [])

  const CardFormador = useMemo(() => {
    let C = () => {
      if (!general.userHasType("secretario_regional", "chefe_nacional", "admin", "diretor_curso", "diretor_adj_curso", "analista_curso", "chefe_regional", "chefe_nucleo"))
        return null;

      const [state, setState] = useReducer(
        (state, newState) => ({...state, ...newState}),
        {
          filter: "",
          mostrar_terminados: false,
          data: {cursos: []},
          page: 0,
          pageSize: 10
        });
      const debouncedFilter = useDebounce(state.filter, 500);

      const apagarCurso = (curso) => {
        setModal(<SweetAlert
          warning
          title="Apagar Curso"
          onConfirm={async () => {
            await connection.post("curso/apagar", {id: curso.id});
            general.success("Curso apagado com sucesso.", "Sucesso!");
            setModal(null)
            reloadCursos();
          }}
          onCancel={() => setModal(null)}
          confirmBtnCssClass={
            classes.button + " " + classes.danger
          }
          cancelBtnCssClass={
            classes.button
          }
          confirmBtnText="Apagar"
          cancelBtnText="Cancelar"
          showCancel
        >
          Atenção! Ao apagar este curso ({curso.descricao}) serão apagadas todas as informaões do mesmo. Não será possível apagar cursos que já têm participantes ou formações.
        </SweetAlert>)
      }

      const reloadCursos = () => {
        let apenas_diretor = !general.userHasType("secretario_regional", "chefe_nacional", "admin", "chefe_regional");

        connection.get("curso/listagem", {
          ocultar_terminados: state.mostrar_terminados ? undefined : 1,
          apenas_diretor: apenas_diretor ? 1 : undefined,
          filtro: state.filter,
          numero_resultados: state.pageSize,
          pagina: state.page
        }).then((data) => {
          let cursos = data.cursos;
          cursos.forEach((curso) => {
            curso.modelo = curso.modelo && curso.modelo.designacao;
            curso.percurso = curso.percurso && curso.percurso.designacao;
            curso.actions = (<React.Fragment>
              <Button
                justIcon
                round
                simple
                onClick={() => {
                  window.App.hist.push("/curso/" + curso.id);
                }}
                style={{margin: 0}}
                color="info"
                className="edit"
              >
                <FontAwesomeIcon icon={faSearchPlus}/>
              </Button>
              {curso.pode_apagar && <Button
                justIcon
                round
                simple
                style={{margin: 0}}
                onClick={() => {
                  apagarCurso(curso);
                }}
                color="danger"
                className="edit"
              >
                <FontAwesomeIcon icon={faTrashAlt}/>
              </Button>}
            </React.Fragment>);
          });

          setState({data: {cursos, paginacao: data.paginacao}})
        });
      }

      async function showNovoCursoModal() {
        let novo_curso = {
          modelo: null,
          diretor: null,
          descricao: null,
          acontecimento_teste: false
        };

        let modelos = await connection.get("modelo/listagem", {apenas_independentes: true, apenas_ativados: true, nao_mostrar_ocultos: true});

        let Content = () => {
          const [modelo, setModelo] = useState(null);
          const [cursoTeste, setCursoTeste] = useState(!!novo_curso.acontecimento_teste);

          return <form autoComplete="off" className={classes.novoCursoForm}>
            <FormControl fullWidth className={classes.selectFormControl}>
              <InputLabel htmlFor="modelo_curso" className={classes.selectLabel}>
                Modelo*
              </InputLabel>
              <Select
                MenuProps={{
                  className: classes.selectMenu
                }}
                classes={{
                  select: classes.select
                }}
                value={modelo}
                onChange={(event) => {
                  novo_curso.modelo = event.target.value;
                  setModelo(event.target.value);
                }}
                inputProps={{
                  name: "modelo_curso",
                  id: "modelo_curso"
                }}
              >
                <MenuItem disabled classes={{root: classes.selectMenuItem}}>Selecione o modelo</MenuItem>
                {modelos.map((modelo) => {
                  return <MenuItem key={Math.random()} classes={{root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}} value={modelo.id}>{modelo.designacao + (modelo.tags ? ' (' + modelo.tags + ')' : '')}</MenuItem>;
                })}
              </Select>
            </FormControl>
            <UserSearch
              labelText="NIN do Diretor"
              id="novoCursoDiretor"
              formControlProps={{
                fullWidth: true
              }}
              inputProps={{
                type: "number",
                min: "0",
                name: "diretor"
              }}
              onFoundUser={(user) => {
                novo_curso.diretor = user.NIN
              }}
            />
            <FormControl fullWidth className={classes.selectFormControl}>
              <InputLabel htmlFor="modo_teste" className={classes.selectLabel}>
                Curso de Teste
              </InputLabel>
              <Select
                MenuProps={{
                  className: classes.selectMenu
                }}
                classes={{
                  select: classes.select
                }}
                value={cursoTeste}
                onChange={(event) => {
                  novo_curso.acontecimento_teste = event.target.value;
                  setCursoTeste(event.target.value);
                }}
                inputProps={{
                  name: "modo_teste",
                  id: "modo_teste"
                }}
              >
                <MenuItem disabled classes={{root: classes.selectMenuItem}}>Selecione se é um curso em modo de teste</MenuItem>
                <MenuItem key={Math.random()} classes={{root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}} value={false}>Não</MenuItem>
                <MenuItem key={Math.random()} classes={{root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}} value={true}>Sim. Apenas para teste. Não será visível pelos outros utilizadores.</MenuItem>
              </Select>
            </FormControl>
          </form>;
        };

        setModal(<SweetAlert
          style={{width: 520}}
          title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
            <span className={classes.modalCardTitle}>Novo Curso</span>
          </div>)}
          onConfirm={() => confirmNovoCurso(novo_curso)}
          onCancel={() => setModal(null)}
          confirmBtnText="Criar"
          showCancel
          cancelBtnText="Cancelar"
          confirmBtnCssClass={
            classes.button + " " + classes.primary + " " + classes.buttonConfirm
          }
          cancelBtnCssClass={
            classes.button
          }
        >
          <div style={{margin: "10px 0px 30px"}}>
            <SnackbarContent
              message={
                'Atenção: está a criar um curso isolado. Caso pretenda criar um curso inserido num percurso, faça-o através da página de percurso.'
              }
              color="warning"
            />
          </div>
          <Content/>
        </SweetAlert>)
      }

      function confirmNovoCurso(novo_curso) {
        connection.post("curso/novo", novo_curso, (result) => {
          window.App.hist.push("/curso/" + result.id);
          general.success("Criado novo curso com sucesso", "Sucesso");
        });
      }

      useEffect(() => {
        reloadCursos();
      }, [state.mostrar_terminados, state.page, debouncedFilter])

      return <Card>
        <CardHeader color="primary">
          <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
            <h4 style={{flex: 1}}>Gerir Cursos</h4>
            <CustomInput
              id="tableSearch"
              formControlProps={{
                className: classes.searchInput
              }}
              inputProps={{
                type: "text",
                name: "tableSearch",
                placeholder: "Pesquisar",
                onChange: (e) => {
                  setState({filter: e.target.value, page: 0});
                }
              }}
            />
            {general.userHasPermission("curso.criar") && <Button className={classes.addCourseButton + " " + classes.button + " " + classes.primary} onClick={showNovoCursoModal}>
              <Add/> Novo Curso
            </Button>}
          </div>
        </CardHeader>
        <ReactTable
          placeholder={general.userHasPermission("curso.criar") ? "Ainda não existe nenhum curso, clique em 'Novo Curso' para começar" : "Não existem cursos para apresentar"}
          data={state.data?.cursos}
          minRows={1}
          columns={[
            {
              Header: "Código",
              accessor: "descricao",
              Cell: (row) => {
                return <React.Fragment><StateCircle state={row.original['estado']}/>{row.original['descricao']}</React.Fragment>
              },
              width: 200
            },
            {
              Header: "Tipo",
              accessor: "tipo_curso",
              Cell: (row) => row.original.tipo_curso + (row.original.tags ? ' (' + row.original.tags + ')' : '')
            },
            {
              Header: "Local",
              accessor: "regiao",
              width: 250,
              Cell: (row) => row.original.nucleo ? row.original.nucleo + ' / ' + row.original.regiao : row.original.regiao
            },
            {
              Header: "Diretor",
              accessor: "diretor",
              width: 150,
              Cell: general.Renderers.userRenderer
            },
            {
              Header: "",
              accessor: "actions",
              maxWidth: 105,
              sortable: false,
              filterable: false
            }
          ]}
          defaultPageSize={state.pageSize}
          showPaginationBottom={true}
          className="-striped -highlight"
          pages={state.data?.paginacao?.paginas}
          manual
          sortable={false}
          onFetchData={(state, instance) => {
            setState({page: state.page, pageSize: state.pageSize});
          }}
        />
        <CardBody style={{textAlign: "right"}}>
          <Button
            className={classes.addStuffButton + " " + classes.button + " " + classes.primary}
            onClick={() => setState({mostrar_terminados: !state.mostrar_terminados})}
            color="success">
            <FontAwesomeIcon icon={state.mostrar_terminados ? faEyeSlash : faEye}/> {state.mostrar_terminados ? "Ocultar" : "Mostrar"} Terminados
          </Button>
        </CardBody>
      </Card>;
    };
    return <C/>
  }, [])

  const CardFormando = useMemo(() => {
    let C = () => {
      if (!general.userHasType("formando") && !general.userHasType("dirigente")) return null;

      const [state, setState] = useReducer(
        (state, newState) => ({...state, ...newState}),
        {
          filter: "",
          mostrar_terminados: false,
          data: {cursos: []},
          page: 0,
          pageSize: 10
        });
      const debouncedFilter = useDebounce(state.filter, 500);

      const reloadCursos = () => {
        connection.get("curso/listagem_inscrito", {
          ocultar_terminados: state.mostrar_terminados ? undefined : 1,
          filtro: state.filter,
          numero_resultados: state.pageSize,
          pagina: state.page
        }).then((data) => {
          let cursos = data.cursos;
          cursos.forEach((curso) => {
            curso.modelo = curso.modelo && curso.modelo.designacao;
            curso.percurso = curso.percurso && curso.percurso.designacao;
            curso.actions = (<React.Fragment>
              <Button
                justIcon
                round
                simple
                onClick={() => {
                  window.App.hist.push("/curso/" + curso.id);
                }}
                style={{margin: 0}}
                color="info"
                className="edit"
              >
                <FontAwesomeIcon icon={faSearchPlus}/>
              </Button>
            </React.Fragment>);
          });

          setState({data: {cursos, paginacao: data.paginacao}})
        });
      }

      useEffect(() => {
        reloadCursos();
      }, [state.mostrar_terminados, state.page, debouncedFilter])

      return <Card>
        <CardHeader color="primary">
          <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
            <h4 style={{flex: 1}}>Cursos {general.userHasType("secretario_regional") ? "da Região" : ""}</h4>
            <CustomInput
              id="tableSearch"
              formControlProps={{
                className: classes.searchInput
              }}
              inputProps={{
                type: "text",
                name: "tableSearch",
                placeholder: "Pesquisar",
                onChange: (e) => {
                  setState({filter: e.target.value, page: 0});
                }
              }}
            />
          </div>
          <p>Consulte abaixo os cursos em que está inscrito.</p>
        </CardHeader>
        <ReactTable
          placeholder={general.userHasPermission("curso.criar") ? "Ainda não existe nenhum curso, clique em 'Novo Curso' para começar" : "Não existem cursos para apresentar"}
          data={state.data?.cursos}
          minRows={1}
          columns={[
            {
              Header: "Código",
              accessor: "descricao",
              Cell: (row) => {
                return <React.Fragment><StateCircle state={row.original['estado']}/>{row.original['descricao']}</React.Fragment>
              },
              width: 200
            },
            {
              Header: "Tipo",
              accessor: "tipo_curso",
              Cell: (row) => row.original.tipo_curso + (row.original.tags ? ' (' + row.original.tags + ')' : ''),
              width: 200
            },
            {
              Header: "Modalidade",
              accessor: "modalidade",
              Cell: (row) => row.original.modalidade + (row.original.tags ? ' (' + row.original.tags + ')' : '')
            },
            {
              Header: "Local",
              accessor: "regiao",
              width: 250,
              Cell: (row) => row.original.nucleo ? row.original.nucleo + ' / ' + row.original.regiao : row.original.regiao
            },
            {
              Header: "Diretor",
              accessor: "diretor",
              width: 150,
              Cell: general.Renderers.userRenderer
            },
            {
              Header: "",
              accessor: "actions",
              maxWidth: 105,
              sortable: false,
              filterable: false
            }
          ]}
          defaultPageSize={state.pageSize}
          showPaginationBottom={true}
          className="-striped -highlight"
          pages={state.data?.paginacao?.paginas}
          manual
          sortable={false}
          onFetchData={(state, instance) => {
            setState({page: state.page, pageSize: state.pageSize});
          }}
        />
        <CardBody style={{textAlign: "right"}}>
          <Button
            className={classes.addStuffButton + " " + classes.button + " " + classes.primary}
            onClick={() => setState({mostrar_terminados: !state.mostrar_terminados})}
            color="success">
            <FontAwesomeIcon icon={state.mostrar_terminados ? faEyeSlash : faEye}/> {state.mostrar_terminados ? "Ocultar" : "Mostrar"} Terminados
          </Button>
        </CardBody>
      </Card>;
    };
    return <C/>
  }, [])

  return <div className={classes.cursosContainer}>
    {modal}
    <GridContainer>
      <GridItem xs={12}>
        {CardDisponiveis}
      </GridItem>
      <GridItem xs={12}>
        {CardFormando}
      </GridItem>
      <GridItem xs={12}>
        {CardFormador}
      </GridItem>
    </GridContainer>
  </div>;
}

export default withStyles(cursosStyle)(Cursos);
